var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "purchase", attrs: { id: "purchase" } },
    [
      _vm.fetching
        ? [
            _c("spinner", {
              attrs: {
                message: "Kaufoptionen werden geladen…",
                margin: "50px auto",
              },
            }),
          ]
        : [
            _vm._m(0),
            _vm._v(" "),
            _c("section", { staticClass: "purchase__options" }, [
              !_vm.articleData.loggedIn
                ? _c(
                    "div",
                    { staticClass: "purchase__option purchase__option--login" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "purchase__button",
                          attrs: { href: _vm.loginUrl, rel: "nofollow" },
                        },
                        [
                          _vm._v(
                            "\n            Anmelden und Artikel sofort lesen\n          "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.freeTrial
                ? _c(
                    "div",
                    {
                      staticClass:
                        "purchase__option purchase__option--free-trial",
                    },
                    [
                      _c(
                        "h1",
                        { staticClass: "purchase__option-header" },
                        [
                          _vm.articleData.magazineDbName === "ct"
                            ? [
                                _vm._v(
                                  "\n            Artikel freischalten +  2 aktuelle Ausgaben c't GRATIS lesen\n          "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n            Anmelden und zwei Monate GRATIS testen\n          "
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("section", { staticClass: "free-trial__container" }, [
                        _c("div", { staticClass: "free-trial__image" }, [
                          _c("img", {
                            staticClass: "purchase__thumbnail",
                            attrs: {
                              src:
                                "/scale/geometry/212/q75" +
                                _vm.freeTrial.thumbnail,
                              alt: "Artikelvorschau",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "section",
                          { staticClass: "free-trial__content" },
                          [
                            _c(
                              "ul",
                              { staticClass: "purchase__benefits" },
                              _vm._l(
                                _vm.freeTrial.benefits,
                                function (benefit) {
                                  return _c(
                                    "li",
                                    {
                                      key: benefit,
                                      staticClass: "purchase__benefit",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(benefit) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _vm.articleData.magazineDbName === "ct"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "purchase__benefits__info" },
                                    [
                                      _vm._v(
                                        "*für iOS, Android und Kindle Fire"
                                      ),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "purchase__button purchase__button--pay",
                                attrs: {
                                  href: _vm.freeTrial.url,
                                  rel: "nofollow",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Jetzt GRATIS testen\n            "
                                ),
                              ]
                            ),
                          ],
                          2
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "purchase__option purchase__option--issue" },
                [
                  _c(
                    "section",
                    { staticClass: "purchase__option-header-container" },
                    [
                      _c("h1", { staticClass: "purchase__option-header" }, [
                        _vm._v("\n            Heft kaufen\n          "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "purchase__option-text" },
                        [
                          _vm._v("\n            Sie können\n            "),
                          _vm.articleData.magazineDbName === "ch"
                            ? [_vm._v("\n              das\n            ")]
                            : [_vm._v("\n              die\n            ")],
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.articleData.magazineScreenName) +
                              "\n            "
                          ),
                          _vm.issue.url
                            ? [
                                _vm._v(
                                  "\n              als PDF oder\n            "
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(
                            "\n            als gedrucktes Heft kaufen.\n          "
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "purchase__thumbnail",
                    attrs: {
                      src:
                        "/scale/geometry/212/q75" +
                        "/select/thumbnail/" +
                        _vm.articleData.magazine +
                        "/" +
                        _vm.articleData.issueYear +
                        "/" +
                        _vm.articleData.issueNumber,
                      alt: "Titelbild",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "purchase__button-container" }, [
                    _vm.articleData.shopUrl && _vm.issue.price
                      ? _c(
                          "form",
                          {
                            attrs: {
                              id: "buy_pdf",
                              method: "POST",
                              action: _vm.articleData.shopUrl,
                            },
                          },
                          [
                            _c("input", {
                              attrs: { type: "hidden", name: "success_url" },
                              domProps: { value: _vm.articleData.url },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "purchase__button purchase__button--pay",
                                attrs: { type: "submit" },
                              },
                              [
                                _vm._v(
                                  "\n              Heft digital kaufen - " +
                                    _vm._s(_vm.issue.price) +
                                    "€\n            "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.issue.url &&
                    _vm.issue.print &&
                    _vm.issue.print.soldOut !== true
                      ? _c(
                          "form",
                          {
                            attrs: {
                              id: "buy_print",
                              method: "POST",
                              action: _vm.articleData.shopPrintUrl,
                            },
                          },
                          [
                            _c("input", {
                              attrs: { type: "hidden", name: "success_url" },
                              domProps: { value: _vm.articleData.url },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "purchase__button purchase__button--pay",
                                attrs: { type: "submit" },
                              },
                              [
                                _vm._v(
                                  "\n              Heft kaufen - " +
                                    _vm._s(_vm.issue.print.price) +
                                    "€\n            "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.issue.url &&
                    _vm.issue.print &&
                    _vm.issue.print.soldOut === true
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "purchase__no__purchase issue__special__info",
                            attrs: { id: "buy_print" },
                          },
                          [
                            _vm._v(
                              "\n            Dieses Heft ist nicht gedruckt erwerbbar.\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.upsell
                ? _c(
                    "div",
                    {
                      staticClass: "purchase__option purchase__option--upsell",
                    },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "purchase__thumbnail",
                        attrs: {
                          src: "/scale/geometry/212/q75" + _vm.upsell.thumbnail,
                          alt: "Artikelvorschau",
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "purchase__option purchase__option--heiseplus" },
                [
                  _c("div", { staticClass: "heiseplus__container" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "heiseplus-header__logo",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 860 200",
                          role: "img",
                          preserveAspectRatio: "xMinYMin",
                          width: "129",
                          height: "30",
                        },
                      },
                      [
                        _c("title", [_vm._v("heise+")]),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            fill: "#6f7d93",
                            d: "M786.24 179.42v-45.19h-43.23v-25.54h43.23V63.5h26.53v45.19H856v25.54h-43.23v45.19z",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            fill: "#14315b",
                            d: "M234.56 191.7V17.43h28.39v44.93l-.99 23.45c5.1-4.77 10.78-9.01 17.04-12.71 6.25-3.7 13.49-5.55 21.73-5.55 13 0 22.47 4.2 28.39 12.59 5.93 8.39 8.89 20.24 8.89 35.55v76.03h-28.39V119.4c0-10.04-1.48-17.11-4.44-21.23-2.96-4.11-7.82-6.17-14.57-6.17-5.27 0-9.92 1.28-13.95 3.83-4.04 2.55-8.6 6.29-13.7 11.23v84.67h-28.39ZM412 194.66c-11.19 0-21.32-2.51-30.37-7.53q-13.575-7.53-21.48-21.72c-5.27-9.46-7.9-20.86-7.9-34.19s2.67-24.52 8.02-34.06 12.3-16.87 20.86-21.97q12.84-7.65 26.91-7.65c11.02 0 20.24 2.43 27.65 7.28 7.41 4.86 13 11.6 16.79 20.24 3.78 8.64 5.68 18.64 5.68 29.99 0 5.92-.41 10.53-1.23 13.82H379.9c1.32 10.7 5.18 19.01 11.6 24.93s14.48 8.89 24.19 8.89c5.27 0 10.16-.78 14.69-2.35 4.52-1.56 9.01-3.74 13.46-6.54l9.63 17.77c-5.76 3.79-12.18 6.91-19.26 9.38s-14.49 3.7-22.22 3.7Zm-32.35-75.04h53.82c0-9.38-2.06-16.74-6.17-22.09-4.12-5.35-10.29-8.02-18.52-8.02-7.08 0-13.37 2.59-18.89 7.78-5.52 5.18-8.93 12.63-10.25 22.34Zm107.62-70.35c-5.1 0-9.22-1.48-12.34-4.44-3.13-2.96-4.69-6.91-4.69-11.85s1.56-8.64 4.69-11.6c3.12-2.96 7.24-4.44 12.34-4.44s9.22 1.48 12.34 4.44 4.69 6.83 4.69 11.6-1.57 8.89-4.69 11.85c-3.13 2.96-7.24 4.44-12.34 4.44M472.95 191.7V70.5h28.39v121.2zm85.47 2.96c-8.23 0-16.46-1.6-24.69-4.81s-15.31-7.2-21.23-11.97l13.33-18.27q8.145 6.18 16.29 9.87c8.145 3.69 11.19 3.7 17.28 3.7 6.58 0 11.44-1.4 14.57-4.2 3.12-2.8 4.69-6.25 4.69-10.37 0-3.46-1.28-6.29-3.83-8.52-2.55-2.22-5.8-4.2-9.75-5.92-3.95-1.73-8.07-3.41-12.34-5.06-5.27-1.97-10.49-4.4-15.68-7.28-5.18-2.88-9.42-6.58-12.71-11.11-3.29-4.52-4.94-10.16-4.94-16.91 0-10.7 3.95-19.42 11.85-26.17s18.6-10.12 32.1-10.12c8.56 0 16.21 1.48 22.96 4.44s12.59 6.34 17.53 10.12l-13.09 17.28q-6.42-4.68-12.96-7.53a34.1 34.1 0 0 0-13.7-2.84c-6.09 0-10.62 1.28-13.58 3.83s-4.44 5.72-4.44 9.5q0 7.155 7.41 10.86c4.94 2.47 10.7 4.86 17.28 7.16 5.59 1.97 11.02 4.4 16.29 7.28s9.67 6.63 13.21 11.23q5.31 6.915 5.31 18.27c0 10.37-4.03 19.22-12.1 26.54s-19.75 10.98-35.06 10.98Zm113.24 0c-11.19 0-21.32-2.51-30.37-7.53q-13.575-7.53-21.48-21.72c-5.27-9.46-7.9-20.86-7.9-34.19s2.67-24.52 8.02-34.06 12.3-16.87 20.86-21.97q12.84-7.65 26.91-7.65c11.02 0 20.24 2.43 27.65 7.28 7.41 4.86 13 11.6 16.79 20.24 3.78 8.64 5.68 18.64 5.68 29.99 0 5.92-.41 10.53-1.24 13.82h-77.03c1.32 10.7 5.18 19.01 11.6 24.93s14.48 8.89 24.19 8.89c5.27 0 10.16-.78 14.69-2.35 4.53-1.56 9.01-3.74 13.46-6.54l9.63 17.77c-5.76 3.79-12.18 6.91-19.26 9.38s-14.49 3.7-22.22 3.7Zm-32.34-75.04h53.82c0-9.38-2.06-16.74-6.17-22.09-4.12-5.35-10.29-8.02-18.52-8.02-7.08 0-13.37 2.59-18.89 7.78-5.52 5.18-8.93 12.63-10.25 22.34ZM107.25 4.65c14.12 6.58 20.23 23.36 13.65 37.48L55.79 181.71c-6.59 14.12-23.37 20.22-37.49 13.64-14.12-6.59-20.23-23.37-13.65-37.48l65.1-139.58C76.34 4.17 93.12-1.93 107.24 4.65m45.08 89.09c-14.12-6.58-30.91-.47-37.49 13.64l-23.55 50.48c-6.59 14.12-.48 30.9 13.65 37.48 14.12 6.58 30.91.47 37.49-13.64l23.55-50.49c6.59-14.12.47-30.9-13.65-37.48",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(3),
                    _vm._v(" "),
                    _c("p", { staticClass: "heiseplus-header__text" }, [
                      _vm._v(
                        "\n            Magazin-Abonnenten erhalten heise+ zum Vorzugspreis.\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "heiseplus-stage-purchase__button-area" },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "purchase__button purchase__button--pay purchase__button--single",
                          attrs: { href: _vm.articleData.checkoutUrl },
                        },
                        [_vm._v("heise+ Abo abschließen")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(4),
                ]
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "purchase__header" }, [
      _c("h3", { staticClass: "purchase__teaser" }, [
        _vm._v("Sie wollen wissen, wie es weitergeht?"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "purchase__option-header-container" }, [
      _c("h1", { staticClass: "purchase__option-header" }, [
        _vm._v("\n            Login\n          "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "purchase__option-text" }, [
        _vm._v(
          "\n            Sie sind Abonnent?\n            Bitte loggen Sie sich hier ein.\n          "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "purchase__option-header-container" }, [
      _c("h1", { staticClass: "purchase__option-header" }, [
        _vm._v("\n            Upsell\n          "),
      ]),
      _vm._v(" "),
      _c("p", {
        staticClass: "purchase__option-text",
        attrs: { "v.-html": "upsell.description" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "h1",
      {
        staticClass:
          "purchase__option-header heiseplus-slogan heiseplus-header__slogan",
      },
      [
        _c("span", { staticClass: "heiseplus-header__subslogan" }, [
          _vm._v("\n              Immer mehr Wissen.\n            "),
        ]),
        _vm._v(
          "\n            Das digitale Abo für IT und Technik.\n          "
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "heiseplus-stage-purchase__link-area" }, [
      _c(
        "a",
        {
          staticClass: "heiseplus-stage-purchase__link",
          attrs: { href: "/plus/info-faq/" },
        },
        [_vm._v("\n            Das ist heise+\n          ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }